var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 31,
    viewBox: "0 0 26 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4319_2029)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.45997 30.4C1.78997 30.4 1.16997 30.13 0.709969 29.63C0.209969 29.09 -0.0500306 28.34 0.00996945 27.63L1.25997 9.64C1.36997 8.48 2.16997 7.31 3.49997 7.31C3.55997 7.31 3.61997 7.31 3.67997 7.31H6.99997V4.78C6.99997 3 7.80997 0 10.82 0H14.82C17.84 0 18.64 3.01 18.64 4.78V7.31H21.94C22.02 7.31 22.08 7.31 22.14 7.31C23.47 7.31 24.28 8.49 24.39 9.65L25.64 27.62C25.64 28.98 24.72 30.4 23.19 30.4H2.45997ZM3.70997 8.45C2.89997 8.45 2.53997 9.21 2.53997 9.74L1.28997 27.58C1.28997 28.34 1.75997 29.14 2.45997 29.14H23.19C23.89 29.14 24.36 28.34 24.36 27.6L23.11 9.72C23.11 9.2 22.75 8.45 21.94 8.45H18.64V10.19H17.37V8.45H8.27997V10.19H7.00997V8.45H3.70997ZM10.83 1.26C9.07997 1.26 8.27997 3.02 8.27997 4.66V7.19H17.5V4.66C17.5 3.25 16.71 1.26 14.95 1.26H10.83Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4319_2029"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.64,
    height: 30.4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag);
export default __webpack_public_path__ + "static/media/shoppingBag.c831f7bf70a3d6db7fe23aa776c0adc9.svg";
export { ForwardRef as ReactComponent };